let Outpatient = function (tokenClient, serviceAddr) {
  let TokenClient = tokenClient
  let ServiceBaseAddress = serviceAddr
  /**
   * 获取药品列表
   * @param {*} categoryId
   * @param {*} pageIndex
   * @param {*} keyWord
   * @param {*} success
   * @param {*} error
   */
  this.DrugOrgList = function (keyWord, categoryId, state, startTime, endTime, pageIndex, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/DrugOrgList`
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    url += `/${categoryId}/${state}`
    if (startTime) {
      url += `/${startTime}`
    } else {
      url += "/%20"
    }
    if (endTime) {
      url += `/${endTime}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 添加药品
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.AddDrugOrg = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/DrugOrg"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  this.AddMZConfirmFeedback = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/MZConfirmFeedback"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  this.AddAddPatientPoint = function (patient,ordeNum, point, success, error) {
      var url = ServiceBaseAddress + "/api/User/AddUserPoint/" + patient +"/" + ordeNum + '/' + point
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
  }


  /**
   * 编辑药品
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.EditDrugOrg = function (item, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/DrugOrg"
    TokenClient.Put(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 获取药品详情
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.MZDrugOrgDetail = function (drugId, success, error) {
    if (drugId) {
      var url = ServiceBaseAddress + "/api/MZDrug/DrugOrg/" + drugId
      TokenClient.Get(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  this.getMZConfirmFeedbackInfo = function (drugId, success, error) {
    if (drugId) {
      var url = ServiceBaseAddress + "/api/MZDrug/MZConfirmFeedbackInfo/" + drugId
      TokenClient.Get(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  
  this.MZPatientIdDetail = function (patientId, success, error) {
    if (patientId) {
      var url = ServiceBaseAddress + "/api/Patient/GetPatientUserId/" + patientId
      TokenClient.Get(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
   * 删除药品
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.RemoveMZDrugOrg = function (id, success, error) {
    if (id) {
      var url = ServiceBaseAddress + `/api/MZDrug/DrugOrg/${id}`
      TokenClient.Delete(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
   * 获取药品分类
   * @param {*} success
   * @param {*} error
   */
  this.GetOutpatientCategories = function (success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/Manager/Categories"
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台--新增药品查询(前10条)
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.DrugByOrgIn = function (keyWord, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/DrugByOrgIn"
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台--获取检查项列表
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.CheckItemList = function (keyWord, pageIndex, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/CheckItemList"
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
  * 添加检查项
  * @param {*} item
  * @param {*} success
  * @param {*} error
  */
  this.AddCheckItem = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/CheckItem"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
   * 编辑检查项
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.EditCheckItem = function (item, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/CheckItem"
    TokenClient.Put(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 删除检查项
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.RemoveCheckItem = function (id, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/CheckItem/${id}`
    TokenClient.Delete(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
  * 获取检查项详情
  * @param {*}
  * @param {*} success
  * @param {*} error
  */
  this.CheckItemDetail = function (id, success, error) {
    if (drugId) {
      var url = ServiceBaseAddress + "/api/MZDrug/CheckItem/" + id
      TokenClient.Get(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
   * 机构后台--获取医嘱列表
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.DoctorAdviceList = function (keyWord, pageIndex, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/DoctorAdviceList"
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 添加医嘱
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.AddDoctorAdvice = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/DoctorAdvice"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
   * 编辑医嘱
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.EditDoctorAdvice = function (item, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/DoctorAdvice"
    TokenClient.Put(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 删除医嘱
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.RemoveDoctorAdvice = function (id, success, error) {
    if (id) {
      var url = ServiceBaseAddress + `/api/MZDrug/DoctorAdvice/${id}`
      TokenClient.Delete(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
   * 机构后台--门诊药品入库
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.AddDrugOrgIn = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/DrugOrgIn"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
   * 机构后台--门诊药品入库管理列表
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.DrugOrgInList = function (keyWord, batchNumber, categoryId, isEmpty, startTime, endTime, pageIndex, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/DrugOrgInList"
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (batchNumber) {
      url += `/${batchNumber}`
    } else {
      url += "/%20"
    }
    url = `${url}/${categoryId}/${isEmpty}`
    if (startTime) {
      url += `/${startTime}`
    } else {
      url += "/%20"
    }
    if (endTime) {
      url += `/${endTime}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
  * 机构后台--门诊药品库存预警
  * @param {*}
  * @param {*} success
  * @param {*} error
  */
  this.DrugOrgInWarn = function (keyWord, categoryId, pageIndex, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/DrugOrgInWarn"
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    url = `${url}/${categoryId}`
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台--门诊药品有效期提醒
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.DrugOrgValidDate = function (categoryId, endTime, pageIndex, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/DrugOrgValidDate"
    url = `${url}/${categoryId}`
    if (endTime) {
      url += `/${endTime}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台--门诊药品入库日志查询
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.DrugOrgInLog = function (keyWord, startTime, endTime, categoryId, batchNumber, supplier, pageIndex, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/DrugOrgInLog"
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (startTime) {
      url += `/${startTime}`
    } else {
      url += "/%20"
    }
    if (endTime) {
      url += `/${endTime}`
    } else {
      url += "/%20"
    }
    url = `${url}/${categoryId}`
    if (batchNumber) {
      url += `/${batchNumber}`
    } else {
      url += "/%20"
    }
    if (supplier) {
      url += `/${supplier}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }

  /**
   * 机构后台--获取添加药品信息(前10条)
   * @param {*}
   * @param {*} success
   * @param {*} error
   */
  this.FindInOrg = function (keyWord, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/FindInOrg/${keyWord}`
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }

  /**
   * 机构后台--直接售药
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.DrugSell = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/DrugSell"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
   * 机构后台--待收费列表
   * @param {*} success
   * @param {*} error
   */
  this.DrugWaitPayMent = function (keyWord, startTime, endTime, pageIndex, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/DrugWaitPayMent`
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (startTime) {
      url += `/${startTime}`
    } else {
      url += "/%20"
    }
    if (endTime) {
      url += `/${endTime}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台-- 待收费详情
   * @param {*} success
   * @param {*} error
   */
  this.DrugPayMentDetail = function (orderId, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/DrugPayMentDetail/${orderId}`
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  
  /**
   * 机构后台--收费
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.DrugPayMent = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/DrugPayMent"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  this.DrugPayBalancePayment = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/BalancePayment"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  this.getIsSetPayPassword = function (success, error) {
      var url = ServiceBaseAddress + "/api/User/IsSetPayPassword"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
  }
  this.getIsPayPassword = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/User/IsPayPassword"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }

  /**
   * 机构后台--退费
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.DrugRefund = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/DrugRefund"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }


  /**
   * 机构后台--已收费列表
   * @param {*} success
   * @param {*} error
   */
  this.DrugAlreadyPayment = function (keyWord, startTime, endTime, pageIndex, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/DrugAlreadyPayment`
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (startTime) {
      url += `/${startTime}`
    } else {
      url += "/%20"
    }
    if (endTime) {
      url += `/${endTime}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  this.GetDrugOrderListByState = function (keyWord, startTime, endTime, pageIndex, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/GetDrugOrderListByState/6,7`
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (startTime) {
      url += `/${startTime}`
    } else {
      url += "/%20"
    }
    if (endTime) {
      url += `/${endTime}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台-- 已收费详情
   * @param {*} success
   * @param {*} error
   */
  this.PaymentedDetail = function (orderId, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/PaymentedDetail/${orderId}`
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台--已退费列表
   * @param {*} success
   * @param {*} error
   */
  this.DrugRefundList = function (keyWord, startTime, endTime, pageIndex, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/DrugRefundList`
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (startTime) {
      url += `/${startTime}`
    } else {
      url += "/%20"
    }
    if (endTime) {
      url += `/${endTime}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
  * 机构后台-- 已退费详情
  * @param {*} success
  * @param {*} error
  */
  this.DrugRefundDetail = function (orderId, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/DrugRefundDetail/${orderId}`
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台--欠款列表
   * @param {*} success
   * @param {*} error
   */
  this.DebtList = function (keyWord, startTime, endTime, pageIndex, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/DebtList`
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (startTime) {
      url += `/${startTime}`
    } else {
      url += "/%20"
    }
    if (endTime) {
      url += `/${endTime}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  
  /**
   * 机构后台-- 欠费详情
   * @param {*} success
   * @param {*} error
   */
  this.DebtDetail = function (orderId, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/DebtDetail/${orderId}`
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台--欠费列表还款
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.DebtRepayment = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/DebtRepayment"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
  * 机构后台--获取机构常用处方列表
  * @param {*}
  * @param {*} success
  * @param {*} error
  */
  this.PrecriptionListOrg = function (type, keyWord, pageIndex, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/PrecriptionListOrg/${type}`
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台--添加门诊处方
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.AddMZPrecription = function (item, success, error) {
    if (item) {
      var url = ServiceBaseAddress + "/api/MZDrug/AddMZPrecription"
      TokenClient.Post(
        url,
        true,
        { "Content-Type": "application/json" },
        item,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
   * 机构后台--编辑门诊处方
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.EditMZPrecription = function (item, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/EditMZPrecription"
    TokenClient.Put(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  this.PrecriptionDetail = function (id, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/PrecriptionDetail/${id}`
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  this.RemovePrecription = function (id, success, error) {
    if (id) {
      var url = ServiceBaseAddress + `/api/MZDrug/prescripId/${id}`
      TokenClient.Delete(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data)
            success(jsonObj)
          }
        },
        error
      )
    }
  }
  /**
  * 机构后台--个人常用处方列表
  * @param {*}
  * @param {*} success
  * @param {*} error
  */
  this.OrgCommonPrescription = function (type, keyWord, pageIndex, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/OrgCommonPrescription/${type}`
    if (keyWord) {
      url += `/${keyWord}`
    } else {
      url += "/%20"
    }
    if (pageIndex) {
      url += `/${pageIndex}`
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 启用禁用药品
   * @param {any} success
   * @param {any} error
   */
  this.IsEnableDrug = function (id, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/IsEnableDrug/${id}`
    TokenClient.Put(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  /**
   * 机构后台--载入
   * @param {*} item
   * @param {*} success
   * @param {*} error
   */
  this.LoadPrescription = function (item, success, error) {
    var url = ServiceBaseAddress + "/api/MZDrug/LoadPrescription"
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  
  /**
   * 退费申请
   * @param {*} orderId
   * @param {*} success
   * @param {*} error
   */
  this.DrugRefundApply = function (orderId, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/DrugRefundApply?orderId=${orderId}`
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  
  this.MZPrescriptionDetail = function(id,success, error) {
    var url = ServiceBaseAddress + '/api/MZDrug/MZPrescriptionDetail/' + id 
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function(data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  this.cacleMZPrescriptionDetail = function(orderId,success, error) {
    var url = ServiceBaseAddress + '/api/MZDrug/CancelMZOrder/' + orderId
    TokenClient.Put(
      url,
      true,
      null,
      null,
      function(data) {
        if (success) {
          var jsonObj = JSON.parse(data)
          success(jsonObj)
        }
      },
      error
    )
  }
  
  this.GetBusinessMZInputInfo = function (startTime, endTime,item, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/GetBusinessMZInputInfo`;
    if (startTime) {
      url += `/${startTime}`;
    } else {
      url += "/%20";
    }
    if (endTime) {
      url += `/${endTime}`;
    } else {
      url += "/%20";
    }
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  
  this.AgentBusinessMZInputList = function (item, keyWord, departmentId, startTime, endTime, pageIndex, pageSize, type, success, error) {
    var url = ServiceBaseAddress + `/api/MZDrug/AgentBusinessMZInputList`;
    if (keyWord) {
      url += `/${keyWord}/${departmentId}`;
    } else {
      url += `/%20/${departmentId}`;
    }
    if (startTime) {
      url += `/${startTime}`;
    } else {
      url += "/%20";
    }
    if (endTime) {
      url += `/${endTime}`;
    } else {
      url += "/%20";
    }
    url += `/${pageIndex}/${pageSize}/${type}`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
}

export { Outpatient }
